"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicListURLService = void 0;
const app_1 = require("app");
const FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
const index_1 = require("Views/Partials/Pages/index");
class DynamicListURLService {
    constructor() {
        this.ALLOWED_URL_PAGE_SIZE = [5, 10, 15];
        this.ALLOWED_URL_SORT = [
            FilterTypings_1.FilterSortOptions.StartDataDesc,
            FilterTypings_1.FilterSortOptions.StartDateAsc,
            FilterTypings_1.FilterSortOptions.TitleAsc,
            FilterTypings_1.FilterSortOptions.FromNowToFuture,
            FilterTypings_1.FilterSortOptions.FromFutureToNow,
            FilterTypings_1.FilterSortOptions.PastEvents,
        ];
    }
    addParamsToUrl(params) {
        Object.entries(params).forEach(([key, value]) => {
            app_1.UrlService.AddToUrl({ key, value: String(value) }, false);
        });
    }
    addDefaultParamsToUrl() {
        const defaultParams = this.getDefaultURLParams();
        Object.entries(defaultParams).forEach(([key, value]) => {
            app_1.UrlService.AddToUrl({ key, value }, false);
        });
    }
    getParamsFromUrl() {
        const result = {};
        const urlParamsObject = app_1.UrlService.GetObjectFromUrlString();
        if (urlParamsObject === null || urlParamsObject === void 0 ? void 0 : urlParamsObject.pageSize) {
            result.pageSize = +urlParamsObject.pageSize;
        }
        if (urlParamsObject === null || urlParamsObject === void 0 ? void 0 : urlParamsObject.page) {
            result.page = +urlParamsObject.page;
        }
        if (urlParamsObject === null || urlParamsObject === void 0 ? void 0 : urlParamsObject.sort) {
            result.sort = urlParamsObject.sort;
        }
        return result;
    }
    areUrlParamsSetAndValid() {
        const urlParams = this.getParamsFromUrl();
        return Object.keys(urlParams).every(paramKey => {
            return this.isValidUrlParam(paramKey, urlParams[paramKey]);
        });
    }
    isValidUrlParam(paramKey, paramValue) {
        switch (paramKey) {
            case 'pageSize':
                return this.isValidUrlPageSize(+paramValue);
            case 'sort':
                return this.isValidUrlSort(paramValue);
            case 'page':
                return +paramValue > 0;
            default:
                return true;
        }
    }
    isValidUrlPageNumber(pageNumber, pageCount) {
        return pageNumber && pageNumber > 0 && pageNumber <= pageCount;
    }
    isValidUrlPageSize(pageSize) {
        return this.ALLOWED_URL_PAGE_SIZE.includes(pageSize);
    }
    isValidUrlSort(sortOrder) {
        return this.ALLOWED_URL_SORT.includes(sortOrder);
    }
    getDefaultURLParams() {
        const params = {
            sort: index_1.PageContext.sortBy,
            pageSize: 10,
            page: 1,
        };
        return params;
    }
}
exports.dynamicListURLService = new DynamicListURLService();
